import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzjxh1RfuSYw04chiQwIV6cjo7lN-9ulD4KZKZb-iVVUhxMsN8OqWjaiOSPzSndOpDB7g/exec';
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.workEmail
        })
      });
      setIsSuccess(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-204">
      <Navigation data-id="element-205" />

      <main className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32" data-id="element-206">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-207">
          {/* Left Column - Info */}
          <div className="space-y-10" data-id="element-208">
            <div data-id="element-209">
              <p className="text-sm text-[#9B9B9B] font-medium mb-4" data-id="element-210">
                We can help
              </p>
              <h1 className="text-4xl sm:text-5xl font-semibold text-gray-900 mb-6" style={{
              fontSize: '32px'
            }} data-id="element-211">
                Talk to our team
              </h1>
            </div>

            {/* Benefits */}
            <div className="space-y-3" data-id="element-212">
              <div className="flex items-center gap-3" data-id="element-213">
                <div className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-214">
                  <Check className="w-3 h-3 text-gray-500" data-id="element-215" />
                </div>
                <span className="text-gray-800" data-id="element-216">
                  Platform demo using your company data
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-217">
                <div className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-218">
                  <Check className="w-3 h-3 text-gray-500" data-id="element-219" />
                </div>
                <a href="https://course.andoe.work" target="_blank" rel="noopener noreferrer" className="text-gray-800 underline underline-offset-2 decoration-[#D0CEC9] hover:decoration-gray-800 transition-colors" data-id="element-220">
                  Check our intro to AI visibility course
                </a>
              </div>

              {/* Course Modules */}
              <div className="ml-8 mt-2 space-y-1.5" data-id="element-221">
                {['Why AI Search Visibility Matters', 'Turning AI Visibility into Product and Market Intelligence', 'Prompt Engineering for Marketers', 'Building the AI Visibility Measurement System', 'How LLMs Form Citations Across the Web Ecosystem', 'Turning AI Visibility into Action', 'Driving Stakeholder Alignment on AI Visibility', 'Governance, Risk, and Systems Thinking in AI Visibility'].map((module, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-222">
                    <span className="text-xs text-[#9B9B9B] font-medium mt-0.5 w-12 flex-shrink-0" data-id="element-223">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm text-[#5C5C5C] leading-snug" data-id="element-224">
                      {module}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Testimonial */}
          </div>

          {/* Right Column - Contact Options */}
          <div className="space-y-6" data-id="element-225">
            {/* Option 1: Request Demo Form */}
            <div className="bg-white rounded-2xl border border-[#E8E6E3] p-8" data-id="element-226">
              <h2 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-227">
                Request a demo
              </h2>

              {isSuccess ? <div className="py-8 text-center" data-id="element-228">
                  <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4" data-id="element-229">
                    <Check className="w-6 h-6 text-gray-600" data-id="element-230" />
                  </div>
                  <p className="text-lg font-medium text-gray-900 mb-2" data-id="element-231">
                    Thanks for reaching out!
                  </p>
                  <p className="text-[#5C5C5C]" data-id="element-232">We'll follow up shortly.</p>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-233">
                  <div data-id="element-234">
                    <input type="text" name="fullName" placeholder="Full name" required value={formData.fullName} onChange={handleChange} className="w-full px-4 py-4 bg-[#FAFAFA] border border-[#E8E6E3] rounded-xl text-gray-900 placeholder:text-[#9B9B9B] focus:outline-none focus:border-gray-400 transition-colors" data-id="element-235" />
                  </div>

                  <div data-id="element-236">
                    <input type="email" name="workEmail" placeholder="Work email" required value={formData.workEmail} onChange={handleChange} className="w-full px-4 py-4 bg-[#FAFAFA] border border-[#E8E6E3] rounded-xl text-gray-900 placeholder:text-[#9B9B9B] focus:outline-none focus:border-gray-400 transition-colors" data-id="element-237" />
                  </div>

                  {error && <p className="text-red-500 text-sm" data-id="element-238">{error}</p>}

                  <button type="submit" disabled={isLoading} className="w-full px-8 py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-all duration-200 disabled:opacity-50" data-id="element-239">
                    {'Request a Demo'}
                  </button>
                </form>}
            </div>

            {/* Divider */}
            <div className="flex items-center gap-4" data-id="element-240">
              <div className="flex-1 h-px bg-[#E8E6E3]" data-id="element-241"></div>
              <span className="text-sm text-[#9B9B9B]" data-id="element-242">or</span>
              <div className="flex-1 h-px bg-[#E8E6E3]" data-id="element-243"></div>
            </div>

            {/* Option 2: Talk to Founder */}
            <div className="bg-white rounded-2xl border border-[#E8E6E3] px-8 py-6 flex items-center justify-between gap-4 flex-wrap" data-id="element-244">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-245">
                Talk to the founder
              </h2>

              <a href="https://www.linkedin.com/in/jason-jm-yang/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-full font-medium hover:bg-gray-900 hover:text-white transition-all duration-200" data-id="element-246">
                Connect and chat
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-247" />
    </div>;
}